module.exports = __webpack_public_path__ + "img/aha-slides-gpt-4.ecb3161b.webp";